import React, { useCallback, useContext, useState } from "react";
import { UploadCloud } from "lucide-react";
import { UserContext } from "components/context/UserContext";
import defaultAvatar from "assets/images/auth/defaultAvatar.png";
import ProfilePictureModal from "./ProfilePictureModal";
import "./ProfilePicturePicker.css";

interface ProfilePicturePickerProps {
  handleChange: (prop: string) => (value: string) => void;
  data: LooseObject;
  prop?: string;
  formErrors?: LooseObject;
}

const ProfilePicturePicker: React.FC<ProfilePicturePickerProps> = ({
  handleChange,
  data,
  prop,
  formErrors,
}) => {
  const { state, dispatch } = useContext(UserContext)!;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const fieldName = prop || "fileUrl";

  const handleOpen = useCallback(() => setIsModalOpen(true), []);
  const handleClose = useCallback(() => setIsModalOpen(false), []);

  const handleUploadSuccess = useCallback(
    (fileUrl: string) => {
      handleChange(fieldName)(fileUrl);
      dispatch({
        type: "SET_PROFILE",
        payload: { profile: { ...state?.profile, [fieldName]: fileUrl } },
      });
    },
    [handleChange, fieldName, dispatch, state?.profile]
  );

  return (
    <div className="ppp-container">
      <img src={data?.[fieldName] || defaultAvatar} className="ppp-avatar" alt="Profile" />
      <button type="button" className="ppp-upload-btn" onClick={handleOpen}>
        <UploadCloud size={16} />
        Upload Image
      </button>
      <p className="ppp-specification">
        (Images can be up to <strong>2MB</strong> in size and should be in portrait rather than
        landscape orientation.)
      </p>
      {formErrors?.[fieldName] && <p className="login-from-helper-text">{formErrors[fieldName]}</p>}

      <ProfilePictureModal
        isOpen={isModalOpen}
        onClose={handleClose}
        currentImageUrl={data?.[fieldName]}
        onUploadSuccess={handleUploadSuccess}
      />
    </div>
  );
};

export default ProfilePicturePicker;
